import {
  AuthActionsUnion,
  AuthActionTypes
} from '@app/modules/core/actions/auth.actions';
import { MeActionsUnion, MeActionTypes } from '@core/actions/me.actions';

export interface State {
  loggedIn: boolean;
  user: any;
}

export const INITIAL_STATE: State = {
  loggedIn: false,
  user: null
};

export function reducer(
  state: State = INITIAL_STATE,
  action: MeActionsUnion | AuthActionsUnion
) {
  switch (action.type) {
    case MeActionTypes.SetMe:
      if (action.user) {
        return { ...state, loggedIn: true, user: action.user };
      } else {
        return {
          ...state,
          loggedIn: false,
          user: null
        };
      }

    case MeActionTypes.UpdateAvatar: {
      const avatarUrl = action.file.fileUrl;
      return {
        ...state,
        user: { ...state.user, avatarUrl }
      };
    }

    case AuthActionTypes.Logout:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export const selectLoggedIn = (state: State) => state.loggedIn;
export const selectUser = (state: State) => state.user;
